import { Calendar, Clock, Users } from "lucide-react"

import { Badge } from "@/components/ui/badge"
import type TryoutCategory from "@/types/serializers/TryoutCategory"

type CategoryCardProps = {
  category: TryoutCategory
}

function formatDate(dateStr: string): string {
  return new Date(dateStr + "T00:00:00").toLocaleDateString("es-AR", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  })
}

function formatTime(timeStr: string): string {
  // Time columns serialize as "2000-01-01T09:00:00.000Z" — extract HH:MM
  const match = timeStr.match(/T(\d{2}:\d{2})/)
  return match ? match[1] : timeStr.slice(0, 5)
}

export default function CategoryCard({ category }: CategoryCardProps) {
  return (
    <div className="border-border bg-card rounded-lg border p-4">
      <div className="mb-2 flex items-center justify-between">
        <span className="text-lg font-bold text-white">{category.label}</span>
        {category.full ? (
          <Badge variant="destructive">Completo</Badge>
        ) : category.spots_remaining !== null ? (
          <Badge variant="secondary">
            {category.spots_remaining} cupos disponibles
          </Badge>
        ) : null}
      </div>
      <div className="text-muted-foreground space-y-1 text-sm">
        <div className="flex items-center gap-2">
          <Calendar className="h-4 w-4" />
          <span>{formatDate(category.date)}</span>
        </div>
        <div className="flex items-center gap-2">
          <Clock className="h-4 w-4" />
          <span>
            {formatTime(category.start_time)} - {formatTime(category.end_time)}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Users className="h-4 w-4" />
          <span>{category.applications_count} inscriptos</span>
        </div>
      </div>
    </div>
  )
}
